import { render, staticRenderFns } from "./Good2Know.vue?vue&type=template&id=de39fede&"
import script from "./Good2Know.vue?vue&type=script&lang=js&"
export * from "./Good2Know.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Good2Know.vue"
export default component.exports